/* ──────────────────────────────────────────────────────────────
   src/main.tsx  (o index.tsx)
   Punto de entrada de React   · React-Query · notistack · AuthProvider
   ────────────────────────────────────────────────────────────── */

import React from 'react';
import ReactDOM from 'react-dom/client';

import { pdfjs } from 'react-pdf'; // worker PDF
import './i18n';
import 'react-tooltip/dist/react-tooltip.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// ❌ OJO: quitamos completamente ReactQueryDevtools
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { SnackbarProvider } from 'notistack';

import App from './App';
import { AuthProvider } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';
import { SnackbarUtilsConfigurator } from './components/utils/snackbar';

import './index.css';

/* Configuración worker PDF */
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

/* Instancia única de React Query */
const qc = new QueryClient();

/* Render principal */
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={4000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <SnackbarUtilsConfigurator />

        {/* AuthProvider + SocketProvider envuelven App */}
        <AuthProvider>
          <SocketProvider>
            <App />
          </SocketProvider>
        </AuthProvider>
      </SnackbarProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
